<template>
  <div class="main-container">
    <loading :isShow="listLoading" />
    <Button type="primary" class="btn export" @click="exportIncreaseStaffData" v-if="reportType == '2-2'">导出本页增员明细</Button>
    <Button type="primary" class="btn export" @click="exportDetailData" v-else>导出本页费用明细</Button>
    <Button class="back-btn" type="primary" ghost @click="back()">返回</Button>

    <div class="top clearfix" v-if="tabVal == 1">
      <div class="its">
        <div class="label">业务员：</div>
        <div class="value">{{ userName }}</div>
      </div>
      <div class="its">
        <div class="label">所属团队：</div>
        <div class="value">{{ groupName }}</div>
      </div>
      <div class="its">
        <div class="label">所属机构：</div>
        <div class="value">{{ orgName }}</div>
      </div>
      <div class="its">
        <div class="label">入职日期：</div>
        <div class="value">{{ entryTime }}</div>
      </div>
      <div class="its">
        <div class="label">结算日期：</div>
        <div class="value">{{ settlementDate }}</div>
      </div>
      <div class="its" v-if="reportType == '4-2'">
        <div class="label">个人奖励：</div>
        <div class="value">{{ activityIncome }}</div>
      </div>
      <div class="its" v-if="reportType == '2-2'">
        <div class="label">增员人数：</div>
        <div class="value">{{ beRecommendedNum }}</div>
      </div>
      <div class="its" v-if="reportType == '2-2'">
        <div class="label">增员奖励：</div>
        <div class="value">{{ activityIncome }}</div>
      </div>
    </div>

    <div class="top clearfix" v-if="tabVal == 2">
      <div class="its" v-if="reportType == '2-2'">
        <div class="label">机构：</div>
        <div class="value">{{ orgName }}</div>
      </div>

      <div class="its" v-if="reportType == '2-2'">
        <div class="label">推荐人人数：</div>
        <div class="value">{{ userNum }}</div>
      </div>

      <div class="its" v-if="reportType == '2-2'">
        <div class="label">增员人数：</div>
        <div class="value">{{ beRecommendedNum }}</div>
      </div>

      <div class="its" v-if="reportType == '2-2'">
        <div class="label">增员奖励：</div>
        <div class="value">{{ activityIncome }}</div>
      </div>
    </div>

    <div class="tableBox">
      <Table :columns="columns" :data="tableData" row-key="uniqueKey">
        <template slot-scope="{ row }" slot="overName_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.workingState == 0, orange: row.isSus == 1 }" v-if="row.owerName"></i>
              <span class="user-name">{{ row.owerStaffNo }}</span>
              <span v-if="row.owerStaffNo">/</span>
              <span class="user-name">{{ row.owerName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="berecommendname_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.beRecommendedWorkingState == 0, orange: row.beRecommendedIsSus == 1 }" v-if="row.beRecommendedName"></i>
              <span class="user-name">{{ row.beRecommendStaffNo }}</span>
              <span v-if="row.beRecommendStaffNo">/</span>
              <span class="user-name">{{ row.beRecommendedName }}</span>
            </div>
          </div>
        </template>

        <template slot-scope="{ row }" slot="recommendname_staffNo">
          <div class="name-status">
            <div class="user-box">
              <i class="dian" :class="{ red: row.recommendWorkingState == 0, orange: row.isSus == 1 }"></i>
              <span class="user-name">{{ row.recommendStaffNo }}</span>
              <span v-if="row.recommendStaffNo">/</span>
              <span class="user-name">{{ row.recommendName }}</span>
            </div>
          </div>
        </template>

        <!-- 推荐人手机号 -->
        <template slot-scope="{ row }" slot="recommendMobile">
          <span class="text" v-if="row.eyeShow">{{ row.mobile }}</span>
          <span class="text" v-else>{{ row.recommendMobile }}</span>
          <span v-if="$units.pointAction('offline_81_4_0_0')">
            <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow" @click="openEye(row.recommendId, row)"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow" @click="openEye(row.recommendId, row)"></i>
          </span>
        </template>

        <!-- 被推荐人手机号 -->
        <template slot-scope="{ row }" slot="beMobile3">
          <span class="text" v-if="row.eyeShow">{{ row.mobile }}</span>
          <span class="text" v-else>{{ row.beRecommendedMobile }}</span>
          <span v-if="$units.pointAction('offline_81_4_0_0')">
            <i class="iconfont iconxianshi eye-icon" v-if="row.eyeShow" @click="openEye(row.beRecommendedId, row)"></i>
            <i class="iconfont iconyincang eye-icon" v-else-if="!row.eyeShow" @click="openEye(row.beRecommendedId, row)"></i>
          </span>
        </template>

        <template slot-scope="{ row }" slot="policyStatus">
          <span>{{ row.policyStatus | showPolicyStatusText }}</span>
        </template>

        <template slot-scope="{ row }" slot="calFactor">
          <span v-if="reportType == '4-2' && rewardType == 3">-</span>
          <span v-else>{{ row.calFactor | calFactorText }}</span>
        </template>

        <template slot-scope="{ row }" slot="receiptStatus">
          <span>{{ row.receiptStatus | receiptStatusText }}</span>
        </template>

        <template slot-scope="{ row }" slot="verifyStatus">
          <span>{{ row.verifyStatus | verifyStatusText }}</span>
        </template>
      </Table>
      <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center; margin-top: 20px" />
    </div>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import { columns } from './form/detailMixin';

export default {
  mixins: [common, pageTool, columns],
  filters: {
    // 保单状态
    showPolicyStatusText(val) {
      switch (val) {
        case '-1':
          return '已退保';
        case '0':
          return '已终止';
        case '1':
          return '已承保';
        case '2':
          return '已中止';
        default:
          return '-';
      }
    },
    // 计算因子
    calFactorText(val) {
      switch (val) {
        case 1:
          return '业务员标保';
        case 2:
          return '业务员规保';
        case 3:
          return '业务员费用';
        default:
          return '-';
      }
    },
    // 回执状态
    receiptStatusText(val) {
      switch (val) {
        case '-1':
          return '无需回执';
        case '0':
          return '待回执';
        case '1':
          return '回执成功';
        case '2':
          return '回执失败';
        default:
          return '-';
      }
    },
    // 回访状态
    verifyStatusText(val) {
      switch (val) {
        case '0':
          return '等待回访';
        case '1':
          return '回访成功';
        case '2':
          return '回访失败';
        case '3':
          return '无需回访';
        default:
          return '-';
      }
    }
  },
  data() {
    return {
      reportId: null,
      tabVal: null,
      orgId: null,
      userId: null,
      tableData: [],
      columns: [],
      userName: '',
      groupName: '',
      orgName: '',
      entryTime: '',
      settlementDate: '',
      reportType: '',
      activityIncome: '',
      beRecommendedNum: '',
      userNum: '',
      conditionalIndicator: '',
      rewardType: ''
    };
  },

  activated() {
    const {
      reportId,
      tabVal,
      orgId,
      userId,
      settlementDate,
      userName,
      groupName,
      orgName,
      entryTime,
      productType,
      reportType,
      activityIncome,
      conditionalIndicator,
      rewardType,
      beRecommendedNum,
      userNum
    } = this.$route.query;

    this.reportType = reportType;
    this.activityIncome = activityIncome;
    this.beRecommendedNum = beRecommendedNum;
    this.userNum = userNum;
    this.reportId = reportId;
    this.tabVal = tabVal;
    this.orgId = orgId;
    this.userId = userId;
    this.settlementDate = settlementDate;
    this.userName = userName;
    this.groupName = groupName;
    this.orgName = orgName;
    this.entryTime = entryTime;
    this.conditionalIndicator = conditionalIndicator;
    this.rewardType = rewardType;
    this.columns = [];

    // 增员
    if (reportType == '2-1') {
      // 无门槛
      this.columns = this.recruitingColumns;
    } else if (reportType == '2-2') {
      this.setPageTitle('增员详情');
      if (this.tabVal == 1) {
        // 梯度-推荐人
        this.columns = this.recruitingUserColumns;
      } else {
        // 梯度-机构
        this.columns = this.recruitingOrgColumns;
      }
    } else {
      // 出单活动
      if (this.tabVal == 1 && productType == 1) {
        // 业务员-个险
        this.columns = this.salesmanInsuranceColumns;
      } else if (this.tabVal == 1 && productType == 2) {
        // 业务员-团财
        this.columns = this.salesmanGroupColumns;
      } else if (this.tabVal == 2 && productType == 1) {
        // 机构-个险
        this.columns = this.orgInsuranceColumns;
      } else if (this.tabVal == 2 && productType == 2) {
        // 机构-团财
        this.columns = this.orgGroupColumns;
      }
    }
    this.getList();
  },
  methods: {
    getList() {
      this.listLoading = true;
      let data = {
        reportId: this.reportId,
        pageSize: this.pageSize,
        pageNo: this.pageNum
      };
      if (this.tabVal == 1) {
        data.userId = this.userId;
      } else {
        data.orgId = this.orgId;
      }
      this.$http({
        url: this.reportType == '2-2' ? '/buz/userSettlementDetail/queryRecommendDetail' : '/buz/userSettlementDetail/getDetail',
        type: 'POST',
        data
      })
        .then(res => {
          if(this.reportType == '2-2') {
            this.tableData = res.data;
            this.total = res.total;
          }else{
            this.tableData = (res.data.dataList && res.data.dataList.records) || [];
            this.total = res.data.dataList.total;
          }
          this.listLoading = false;
        })
        .catch(e => {
          this.listLoading = false;
        });
    },

    exportDetailData() {
      if (!this.$units.pointAction('offline_81_4_4')) {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let data = {
        reportId: this.reportId
      };
      if (this.tabVal == 1) {
        data.userId = this.userId;
      } else {
        data.orgId = this.orgId;
      }
      this.$units.downloadFile('/buz/userSettlementDetail/exportDetail', data, 'POST');
    },

    // 导出增员明细
    exportIncreaseStaffData() {
      let data = {
        reportId: this.reportId
      };
      if (this.tabVal == 1) {
        data.userId = this.userId;
      } else {
        data.orgId = this.orgId;
      }
      this.$units.downloadFile('/buz/userSettlementDetail/exportRecommendDetail', data, 'POST');
    },

    // 解密
    openEye(id, row) {
      if (!row.eyeShow) {
        this.descrypt(
          {
            query: id,
            operationFunction: 47,
            operationType: 2
          },
          row,
          'mobile',
          'offline_81_4_0_0'
        ).then(() => {
          this.$set(row, 'eyeShow', true);
        });
      } else {
        this.$set(row, 'eyeShow', false);
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.export {
  margin-bottom: 20px;
}
.top {
  padding: 10px 0 25px 0px;
  padding-bottom: 0;
  .its {
    > div {
      float: left;

      &.label {
        font-weight: bold;
        color: #515c6f;
        font-size: 14px;
        margin-right: 10px;
      }

      &.value {
        color: #272933;
      }
    }

    width: 25%;
    float: left;
    margin-bottom: 20px;
  }
}
.back-btn {
  position: absolute;
  right: 20px;
}
.title {
  font-size: 18px;
  font-weight: 800;
  margin-bottom: 15px;
}
.tableBox {
  margin-top: 20px;
}
.name-status {
  align-items: center;
  /deep/ .user-box {
    font-size: 12px;
    .dian {
      display: inline-block;
      flex-shrink: 0;
      width: 5px;
      height: 5px;
      background: #35bf3f;
      border-radius: 50%;
      margin-right: 4px;
      &.red {
        background: #e3461f;
      }
      &.orange {
        background: #ff9900 !important;
      }
    }
    &.text {
      color: #515c6f;
    }
    .user-name {
      font-size: 13px;
      &.dashed {
        border-bottom: 1px dashed #236dff;
      }
      &.line {
        border-bottom: 1px solid #236dff;
      }
    }
    i {
      color: #bababa;
      font-size: 13px;
    }
    .iconduichang {
      margin-left: 4px;
    }
    &.no-token {
      color: #515c6f;
      .user-name {
        cursor: auto;
      }
    }
  }
}
</style>
